import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	titleForSprintCapacityFlyout: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.title-for-sprint-capacity-flyout',
		defaultMessage: 'SPRINT',
		description: 'Title for the sprint capacity flyout',
	},
	sprintCapacityLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-capacity-label',
		defaultMessage: 'Sprint capacity ({planningUnit})',
		description: 'Label for the sprint capacity',
	},
	sprintAllocationLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-allocation-label',
		defaultMessage: '{numerator}/{denominator} {unit} allocated',
		description: 'Label for the sprint allocation',
	},
	sprintDoneLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-done-label',
		defaultMessage: '{numerator}/{denominator} {unit} done',
		description: 'Label for the sprint allocation',
	},
	sprintStartDateLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-start-date-label',
		defaultMessage: 'Sprint start date',
		description: 'Label for the sprint start date',
	},
	sprintEndDateLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-end-date-label',
		defaultMessage: 'Sprint end date',
		description: 'Label for the sprint end date',
	},
	sprintDatesMissing: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-dates-missing',
		defaultMessage:
			"{sprintName} has no start or end date. We've inferred dates based on your program board.",
		description: 'Sprint dates missing',
	},
	sprintIconLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-icon-label',
		defaultMessage: 'Sprint',
		description: 'Label for the sprint icon',
	},
	sprintCapacityOverviewLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-capacity-overview-label',
		defaultMessage: 'Sprint capacity overview',
		description: 'Label for the sprint overview icon',
	},
	sprintStartDateInfoIconLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-start-date-info-icon-label',
		defaultMessage: 'Sprint start date info',
		description: 'Label for the sprint start date icon',
	},
	sprintEndDateInfoIconLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-end-date-info-icon-label',
		defaultMessage: 'Sprint end date info',
		description: 'Label for the sprint end date icon',
	},
	closeIconLabel: {
		id: 'portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.close-icon-label',
		defaultMessage: 'Close',
		description: 'Label for the close icon',
	},
});
